var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo, useState } from 'react';
import { BlockControlsWrapper } from './BlockControlsWrapper';
import { RGBAToHexA } from '@web/utils';
import { styled, useTheme } from '@web/theme';
import { useBlock, useBlockEdit, blockEditActions, BlockType } from '../../';
import { usePageEdit, ColorPicker, ColorPreview, CheckBox } from '../../../';
import { BlockDimensions } from './BlockDimensions';
export var BlockControlsBottom = memo(function (_a) {
    var _b, _c, _d;
    var id = _a.id;
    var theme = useTheme();
    var block = useBlock(id).block;
    var pageEdit = usePageEdit().pageEdit;
    var _e = useBlockEdit(), blockEdit = _e.blockEdit, dispatchBlockEdit = _e.dispatchBlockEdit;
    var _f = useState(null), openColor = _f[0], setOpenColor = _f[1];
    var onOpenColorSelect = function (colorId) {
        setOpenColor(colorId === openColor ? null : colorId);
    };
    var _onColorPreview = function (data) {
        var _a;
        dispatchBlockEdit({
            type: blockEditActions.ADD,
            block: __assign(__assign(__assign({}, block), blockEdit.data), (_a = {}, _a[data.field] = RGBAToHexA(data.color.rgb), _a))
        });
    };
    var useBlockColor = ((_b = blockEdit.data) === null || _b === void 0 ? void 0 : _b.color) || block.color || theme.accent3rd.txt;
    var useBlockBg = ((_c = blockEdit.data) === null || _c === void 0 ? void 0 : _c.bg) || block.bg || theme.accent3rd.bg;
    if (!pageEdit.enabled)
        return null;
    return (React.createElement(Wrapper, null,
        React.createElement(Flex, null,
            React.createElement(CheckBox, { blockId: id, field: "shadow", label: "St\u00EDn" }),
            React.createElement(CheckBox, { blockId: id, field: "box", label: "Box" }),
            React.createElement(CheckBox, { blockId: id, field: "margin", label: "Odsazen\u00ED" }),
            React.createElement(CheckBox, { blockId: id, field: "checkLinkContrast", label: "Kontrast" }),
            React.createElement("br", null),
            block._type === BlockType.TEXT &&
                React.createElement(React.Fragment, null,
                    React.createElement("label", null,
                        React.createElement(ColorPreview, { id: "bg", color: useBlockBg, onClick: onOpenColorSelect, blockBg: useBlockBg }),
                        "Pozad\u00ED"),
                    React.createElement("label", null,
                        React.createElement(ColorPreview, { id: "color", color: useBlockColor, onClick: onOpenColorSelect, blockBg: useBlockBg }),
                        "Text")),
            block._type === BlockType.IMAGE &&
                React.createElement(BlockDimensions, { id: id })),
        openColor &&
            React.createElement(Flex, null,
                React.createElement(ColorPicker, { id: openColor, onPreview: _onColorPreview, onChange: _onColorPreview, color: ((_d = blockEdit.data) === null || _d === void 0 ? void 0 : _d[openColor]) || (block === null || block === void 0 ? void 0 : block[openColor]) || theme.accent3rd.bg }))));
});
var Wrapper = styled(BlockControlsWrapper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tflex-direction: column;\n"], ["\n\tflex-direction: column;\n"])));
var Flex = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\twidth: 100%;\n\tmin-height: 30px;\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-items: center;\n\tjustify-content: flex-start;\n"], ["\n\twidth: 100%;\n\tmin-height: 30px;\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-items: center;\n\tjustify-content: flex-start;\n"])));
var templateObject_1, templateObject_2;
